import { List, Map } from 'immutable';
import { records } from '@saucelabs/sl-module-user';
import { constants as LOG_CONSTANTS } from '@saucelabs/sl-component-log';

import { APP_FILTER_NAME as APP } from '../file/constants';
import * as constants from './constants';
import * as types from './types';

const getCachedInitialColumnsRatio = () => {
  try {
    return JSON.parse((
      window.localStorage.getItem(constants.LS_TEST_DETAILS_COLUMNS_RATIO) ||
      constants.INITIAL_COLUMNS_RATIO
    ));
  } catch (error) {
    return constants.INITIAL_COLUMNS_RATIO;
  }
};

const setCachedInitialColumnsRatio = (payload) => {
  const newRatio = typeof payload === 'string' ? parseFloat(payload) : payload;
  window.localStorage.setItem(constants.LS_TEST_DETAILS_COLUMNS_RATIO, newRatio);

  return newRatio;
};

const initialState = Map({
  commandsFilter: {
    phrase: '',
    hasScreenshot: false,
    hasRootCause: false,
    hasPerformance: false,
    showFailedTests: false,
  },
  galleryFullScreen: false,
  loading: true,
  notifications: List(),
  player: {},
  ratio: getCachedInitialColumnsRatio(),
  openSauceUser: null,
  logsViewerState: {
    appFilter: APP,
    searchExpanded: false,
    textWrapped: false,
    filter: {
      phrase: null,
      regex: false,
      ignoreCase: false,
      invert: false,
    },
    logLevel: LOG_CONSTANTS.LEVELS.WARN,
    logLevels: LOG_CONSTANTS.LEVELS,
  },
});

const containerReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.INITIALIZE.SUCCESS:
      return state.set('loading', false);
    case types.VIDEO_PLAYER_MOUNTED:
      return state.set('player', payload);
    case types.UPDATE_COLUMNS_RATIO: {
      const newRatio = setCachedInitialColumnsRatio(payload);
      return state.set('ratio', newRatio);
    }
    case types.APPEND_NOTIFICATION: {
      const notifications = state.get('notifications');
      return state.set('notifications', notifications.push(payload));
    }
    case types.UPDATE_COMMANDS_FILTER:
      return state.set('commandsFilter', {
        ...state.get('commandsFilter'),
        ...payload,
      });
    case types.SET_GALLERY_FULL_SCREEN:
      return state.set('galleryFullScreen', payload);
    case types.SET_OPEN_SAUCE_USER:
      return state.set('openSauceUser', new records.UserRecord(payload));
    case types.CLEANUP:
      return initialState;
    case types.UPDATE_LOGS_VIEWER_STATE:
      return state.set('logsViewerState', payload);
    default:
      return state;
  }
};

export default containerReducer;
